/*
  Botão "Adicionar" da sugestão no carrinho.
  Segue o mesmo caminho do product-form do tema: dispara CartLinesUpdateEvent
  com uma promise, adiciona via /cart/add.js pedindo as seções do carrinho e
  resolve a promise com o HTML novo — o cart-items-component do tema troca o
  conteúdo da gaveta/página sozinho (lista, barra de frete, totais, sugestão).
*/
import { CartLinesUpdateEvent } from '@shopify/events';

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-nk-sug-add]');
  if (!btn || btn.disabled) return;
  btn.disabled = true;

  const id = btn.getAttribute('data-nk-sug-add');
  const secoes = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);

  const deferred = CartLinesUpdateEvent.createPromise();
  btn.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: id, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const body = new FormData();
    body.append('id', id);
    body.append('quantity', '1');
    if (secoes.length) body.append('sections', secoes.join(','));

    const res = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body,
    }).then((r) => r.json());

    if (res.status) throw new Error(res.description || res.message || 'Erro ao adicionar');

    const carrinho = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(carrinho),
      detail: {
        items: carrinho.items,
        source: 'nordk-sugestao',
        sourceId: 'nordk-sugestao',
        itemCount: 1,
        sections: res.sections,
        didError: false,
      },
    });
  } catch (err) {
    deferred.reject?.(err);
    btn.disabled = false;
    const txt = btn.querySelector('.nk-sug__txt');
    if (txt) txt.textContent = 'Esgotou';
  }
});
